import { abeStylists } from 'actions/stylist/beSalonStylists.action';
import reduceGetServices from 'reducers/salonInfo/reduceGetServices.fold';
import reduceStylists from 'reducers/salonInfo/reduceStylists.fold';
import asReducer from 'utils/functions/asReducer.util';

// TODO: replace this one and the 3 others with new action beGetServices
const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';

const initState = () => ({
  categoryList: [],
  categoryMap: {},
  serviceList: [],
  serviceMap: {},
  stylistsList: [],
  stylistsMap: {},
});

const MAP = Object.freeze({
  [GET_CATEGORIES_SUCCESS]: reduceGetServices,
  [abeStylists.AT.pass]: reduceStylists,
});

const salonInfoReducer = (state, action) => asReducer(MAP[action?.type])(state ?? initState(), action ?? {});

// noinspection JSUnusedGlobalSymbols
export default salonInfoReducer;
